import React, { useContext, useEffect, useState } from "react";
import HomeBanner from "./HomeBanner/HomeBanner";
import ShopBySeller from "./ShopBySeller/ShopBySeller";
import PopularCategories from "./PopularCategories/PopularCategories";
import OurProduct from "./OurProduct/OurProduct";
import SelectByCategories from "./SelectByCategories/SelectByCategories";
import Near_By_Stores from "./near_by_stores/Near_By_Stores";
import Festival_Products from "./festival_products/Festival_Products";
import Offers_Slider from "./offers_slider/Offers_Slider";
import Offer_Banner from "./offer_banner/Offer_Banner";
import New_In_Store from "./new_in_store/New_In_Store";
import Popular_Product from "./popular_product/Popular_Product";
import "./HomePage.css";
import Popular_Product_Mobile_View from "./popular_product_mobile_view/Popular_Product_Mobile_View";
import Offer_Products from "./offer_products/Offer_Products";
import { SaleBanner } from "../../utils/apis/Product/Product";
import { Context } from "../../utils/context";
import {
  getAllCoupon,
  getCoupon,
  getCouponCode,
} from "../../utils/apis/orderProcess/orderProcess";

const HomePage = () => {
  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
  const [saleBanner, setsaleBanner] = useState([]);

  const getProduct = async () => {
    setShimmerLoader(true);
    const res = await SaleBanner();
    if (res?.success) {
      setsaleBanner(res?.data);

      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  const [coupon, setCoupon] = useState([]);
  const getCoupondata = async () => {
    const res = await getAllCoupon();
    if (res?.success) {
      setCoupon(res?.data);
    }
  };

  useEffect(() => {
    getCoupondata();
  }, []);

  return (
    <>
      <section className="Home">
        <div className="container">
          <div className="desktop_view">
            <div className="row me-0 ms-0">
              <div className="col-xxl-2 col-xl-3 col-lg-3 p-0">
                <div className="row justify-content-between custom_row me-0 ms-0">
                  <div className="col-lg-12 col-sm-6">
                    <div className="popular_prod_desktop">
                      <Popular_Product />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-10 col-xl-9 col-lg-9 p-0">
                <div className="body_container">
                  <HomeBanner />
                  <Near_By_Stores />
                  <Festival_Products />
                  {/* <div className="popular_prod_mobile">
                    <Popular_Product_Mobile_View />
                  </div> */}
                  <Offers_Slider coupon={coupon} IMG_URL={IMG_URL} />
                  {/* <ShopBySeller />    old component*/}
                  <PopularCategories />
                  {saleBanner[0] && (
                    <Offer_Banner imgSrc={IMG_URL + saleBanner[0].image} />
                  )}
                  <New_In_Store />
                  {/* <OurProduct />  old component*/}
                  {saleBanner[1] && (
                    <Offer_Banner imgSrc={IMG_URL + saleBanner[1].image} />
                  )}
                  <Offer_Products />

                  {/* <SelectByCategories /> old component */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
